import React from "react";
import { CodeValidationResultWithIcon } from "./CodeValidationResultWithIcon";
import { CompilationError } from "../../../data/ValidationResult";
import { SyncProblem } from "@mui/icons-material";
import {useTranslation} from "react-i18next";

interface CompilationErrorComponentProps {
    error: CompilationError;
}

export function CompilationErrorComponent(
    props: CompilationErrorComponentProps
) {
    const { error } = props;
    const { t } = useTranslation();

    return (
        <CodeValidationResultWithIcon icon={<SyncProblem color="primary" />}>
            {t("codeAssignmentPage:validation:compilationError") + ":"}
            {error.errors.map((error, index) => (
                <div key={index}>
                    <samp>{error}</samp>
                </div>
            ))}
        </CodeValidationResultWithIcon>
    );
}
